import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const BrandGuidelinesForNRO = lazy(() =>
  import("@scenes/CopywriterSettings").then((module) => ({
    default: module.CopywriterSettings,
  }))
);

export const brandGuidelinesNRO: NavigationRoutingObject = {
  Component: BrandGuidelinesForNRO,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("copywriter-settings-nro-heading", "Brand Guidelines"),
  pageNameForTracking: () => "Brand Guidelines",
  getDeveloperNavigationAllowed: () => true,
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
};
